// regex for utm campaigns
const socialTypeUtmPattern = /social_.+_perf/;
const displayTypUtmPattern = /display_.+_perf/;
const vlaTypeUtmPattern = /sem_listing.+_perf/;

export default function isVDPExperienceUTM(query) {
    const utm = query?.utm_medium || '';
    const isSem = vlaTypeUtmPattern.test(utm);
    const isSocial = socialTypeUtmPattern.test(utm);
    const isDisplay = displayTypUtmPattern.test(utm);

    return isSem || isSocial || isDisplay;
}
